/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SkillsPhotoMetadata {
  missionExecutionId: string;
  actionResultId: string;
  capturePointName: string;
  structureName: string;
  structureId: string;
  assetId: string;
  assetCustomerId: string;
  capturePointId: string;
}

function createBaseSkillsPhotoMetadata(): SkillsPhotoMetadata {
  return {
    missionExecutionId: "",
    actionResultId: "",
    capturePointName: "",
    structureName: "",
    structureId: "",
    assetId: "",
    assetCustomerId: "",
    capturePointId: "",
  };
}

export const SkillsPhotoMetadata = {
  encode(message: SkillsPhotoMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.missionExecutionId !== "") {
      writer.uint32(10).string(message.missionExecutionId);
    }
    if (message.actionResultId !== "") {
      writer.uint32(18).string(message.actionResultId);
    }
    if (message.capturePointName !== "") {
      writer.uint32(26).string(message.capturePointName);
    }
    if (message.structureName !== "") {
      writer.uint32(34).string(message.structureName);
    }
    if (message.structureId !== "") {
      writer.uint32(42).string(message.structureId);
    }
    if (message.assetId !== "") {
      writer.uint32(58).string(message.assetId);
    }
    if (message.assetCustomerId !== "") {
      writer.uint32(66).string(message.assetCustomerId);
    }
    if (message.capturePointId !== "") {
      writer.uint32(50).string(message.capturePointId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkillsPhotoMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkillsPhotoMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.missionExecutionId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.actionResultId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.capturePointName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.structureName = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.structureId = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.assetId = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.assetCustomerId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.capturePointId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkillsPhotoMetadata {
    return {
      missionExecutionId: isSet(object.missionExecutionId) ? globalThis.String(object.missionExecutionId) : "",
      actionResultId: isSet(object.actionResultId) ? globalThis.String(object.actionResultId) : "",
      capturePointName: isSet(object.capturePointName) ? globalThis.String(object.capturePointName) : "",
      structureName: isSet(object.structureName) ? globalThis.String(object.structureName) : "",
      structureId: isSet(object.structureId) ? globalThis.String(object.structureId) : "",
      assetId: isSet(object.assetId) ? globalThis.String(object.assetId) : "",
      assetCustomerId: isSet(object.assetCustomerId) ? globalThis.String(object.assetCustomerId) : "",
      capturePointId: isSet(object.capturePointId) ? globalThis.String(object.capturePointId) : "",
    };
  },

  toJSON(message: SkillsPhotoMetadata): unknown {
    const obj: any = {};
    if (message.missionExecutionId !== "") {
      obj.missionExecutionId = message.missionExecutionId;
    }
    if (message.actionResultId !== "") {
      obj.actionResultId = message.actionResultId;
    }
    if (message.capturePointName !== "") {
      obj.capturePointName = message.capturePointName;
    }
    if (message.structureName !== "") {
      obj.structureName = message.structureName;
    }
    if (message.structureId !== "") {
      obj.structureId = message.structureId;
    }
    if (message.assetId !== "") {
      obj.assetId = message.assetId;
    }
    if (message.assetCustomerId !== "") {
      obj.assetCustomerId = message.assetCustomerId;
    }
    if (message.capturePointId !== "") {
      obj.capturePointId = message.capturePointId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkillsPhotoMetadata>, I>>(base?: I): SkillsPhotoMetadata {
    return SkillsPhotoMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkillsPhotoMetadata>, I>>(object: I): SkillsPhotoMetadata {
    const message = createBaseSkillsPhotoMetadata();
    message.missionExecutionId = object.missionExecutionId ?? "";
    message.actionResultId = object.actionResultId ?? "";
    message.capturePointName = object.capturePointName ?? "";
    message.structureName = object.structureName ?? "";
    message.structureId = object.structureId ?? "";
    message.assetId = object.assetId ?? "";
    message.assetCustomerId = object.assetCustomerId ?? "";
    message.capturePointId = object.capturePointId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
